import { canv } from "@/canv/global.js";
import { getTarget } from "@/canv/utils.js";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

type OptionsList = widgetOption<string>[];

export class WmMindMapDirection extends wmBase {
    constructor(options: OptionsList) {
        super();
        this.options = options;
    }

    build() {
        const uniqValues = Array.from(new Set(this.options.map((opt) => opt.value)));
        const direction = uniqValues[0];
        const view = this.viewData[direction];

        return `
            <div class="wm_textAlign">
                ${view}
            </div>
        `;
    }

    init() {
        const item = document.querySelector(".wm_textAlign");
        item?.removeEventListener("click", this.showSubMenu, false);
        item?.addEventListener("click", this.showSubMenu, false);
    }

    showSubMenu = (e) => {
        const subm = document.querySelector(".wm_textAlign_submenu");
        if (subm) {
            subm.outerHTML = "";
            return;
        }
        const otherSubm = document.querySelector(".widgetSubMenu");
        if (otherSubm) {
            otherSubm.outerHTML = "";
        }

        canv.widgetMenu.subMenuBoss = "wm_textAlign";
        const submenu = document.createElement("div");
        submenu.classList.add("widgetSubMenu");
        submenu.classList.add("wm_textAlign_submenu");
        submenu.style.opacity = "0";
        document.body.prepend(submenu);

        submenu.innerHTML += this.submenuTemplate(this.viewData.horizontal, "horizontal");
        submenu.innerHTML += this.submenuTemplate(this.viewData.vertical, "vertical");

        const items = document.querySelectorAll(".wm_textAlign_submenu_item");
        for (let i = 0; i < items.length; i++) {
            items[i].removeEventListener("mouseup", this.itemClick, false);
            items[i].addEventListener("mouseup", this.itemClick, false);
        }

        setTimeout(canv.widgetMenu.TryLocateMenu.bind(canv.widgetMenu), 50);
    };

    itemClick = (e) => {
        const item = getTarget(e, "wm_textAlign_submenu_item");
        const directionType = item.getAttribute("directionType");

        this.applyValue(this.options, directionType);

        const menuItem = document.querySelector(".wm_textAlign");
        if (menuItem) {
            menuItem.innerHTML = this.viewData[directionType];
        }
    };

    submenuTemplate(view, type) {
        return `
            <div class="wm_textAlign_submenu_item" directionType=${type}>
                ${view}
            </div>
        `;
    }

    name = "wm_mindMapDirection";
    options: OptionsList = [];
    viewData = {
        horizontal: `
                <svg width="23" height="24" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 0.5C6.33696 0.5 5.70107 0.763392 5.23223 1.23223C4.76339 1.70107 4.5 2.33696 4.5 3V4.5H1C0.867392 4.5 0.740215 4.55268 0.646447 4.64645C0.552678 4.74021 0.5 4.86739 0.5 5C0.5 5.13261 0.552678 5.25979 0.646447 5.35355C0.740215 5.44732 0.867392 5.5 1 5.5H4.5V7C4.5 7.66304 4.76339 8.29893 5.23223 8.76777C5.70107 9.23661 6.33696 9.5 7 9.5H9C9.13261 9.5 9.25979 9.44732 9.35355 9.35355C9.44732 9.25979 9.5 9.13261 9.5 9C9.5 8.86739 9.44732 8.74021 9.35355 8.64645C9.25979 8.55268 9.13261 8.5 9 8.5H7C6.60218 8.5 6.22064 8.34196 5.93934 8.06066C5.65804 7.77936 5.5 7.39782 5.5 7V5.5H9C9.13261 5.5 9.25979 5.44732 9.35355 5.35355C9.44732 5.25979 9.5 5.13261 9.5 5C9.5 4.86739 9.44732 4.74021 9.35355 4.64645C9.25979 4.55268 9.13261 4.5 9 4.5H5.5V3C5.5 2.60218 5.65804 2.22064 5.93934 1.93934C6.22064 1.65804 6.60218 1.5 7 1.5H9C9.13261 1.5 9.25979 1.44732 9.35355 1.35355C9.44732 1.25979 9.5 1.13261 9.5 1C9.5 0.867392 9.44732 0.740215 9.35355 0.646447C9.25979 0.552678 9.13261 0.5 9 0.5H7Z" fill="black"/>
                </svg>
            `,
        vertical: `
                <svg width="23" height="23" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.5 7C9.5 6.33696 9.23661 5.70107 8.76777 5.23223C8.29893 4.76339 7.66304 4.5 7 4.5H5.5V1C5.5 0.867392 5.44732 0.740215 5.35355 0.646447C5.25979 0.552678 5.13261 0.5 5 0.5C4.86739 0.5 4.74021 0.552678 4.64645 0.646447C4.55268 0.740215 4.5 0.867392 4.5 1V4.5H3C2.33696 4.5 1.70107 4.76339 1.23223 5.23223C0.763392 5.70107 0.5 6.33696 0.5 7V9C0.5 9.13261 0.552678 9.25979 0.646447 9.35355C0.740215 9.44732 0.867392 9.5 1 9.5C1.13261 9.5 1.25979 9.44732 1.35355 9.35355C1.44732 9.25979 1.5 9.13261 1.5 9V7C1.5 6.60218 1.65804 6.22064 1.93934 5.93934C2.22064 5.65804 2.60218 5.5 3 5.5H4.5V9C4.5 9.13261 4.55268 9.25979 4.64645 9.35355C4.74021 9.44732 4.86739 9.5 5 9.5C5.13261 9.5 5.25979 9.44732 5.35355 9.35355C5.44732 9.25979 5.5 9.13261 5.5 9V5.5H7C7.39782 5.5 7.77936 5.65804 8.06066 5.93934C8.34196 6.22064 8.5 6.60218 8.5 7V9C8.5 9.13261 8.55268 9.25979 8.64645 9.35355C8.74021 9.44732 8.86739 9.5 9 9.5C9.13261 9.5 9.25979 9.44732 9.35355 9.35355C9.44732 9.25979 9.5 9.13261 9.5 9V7Z" fill="black"/>
                </svg>
            `,
    };
}
